import { action, observable } from 'mobx';

import {
    getReplenishmentFrequencyByCollectionId,
    updateReplenishment as _updateReplenishment
} from '~api/ReplenismentAPI/ReplenishmentAPI';
import FetchedCartInfoUseCase from '~use-cases/FetchedCartInfoUseCase';

import { IUpdateReplenishmentPayload } from '~views/ShoppingBagTab/CartSidebarItems/CartItem/ReplenishmentComponent/IReplenishmentComponent';

export default class ReplenishmentViewController {
    @observable public selectedValue: string;
    @observable public collectionId: string;
    @observable public isLoading: boolean = false;

    @action
    public getReplenishmentFrequency = ({ collectionId }: { collectionId: string }) => {
        this.isLoading = true;
        getReplenishmentFrequencyByCollectionId(collectionId).then((replenishmentFrequency) => {
            if (replenishmentFrequency) {
                this.setSelected(replenishmentFrequency);
            }
            this.isLoading = false;
        });
    };

    @action
    public updateReplenishment = async ({
        cartItem,
        selectedFrequency
    }: IUpdateReplenishmentPayload) => {
        this.isLoading = true;
        try {
            const SKU_BASE_ID = cartItem?.skuId;
            const REPLENISHMENT_FREQ = parseInt(selectedFrequency, 10);
            const _TOKEN = cartItem?.replenishmentInfo?.replenishmentToken;

            const result = await _updateReplenishment({
                REPLENISHMENT_FREQ,
                SKU_BASE_ID,
                COLLECTION_ID: this.collectionId,
                _TOKEN
            });

            const { collectionId } = result;
            const newCollectionId = collectionId?.toString() || '';

            this.setCollectionId(newCollectionId);
        } finally {
            await new FetchedCartInfoUseCase().execute();
            this.isLoading = false;
        }
    };

    @action public setSelected = (newVal: string) => (this.selectedValue = newVal);
    @action public setCollectionId = (newVal: string) => (this.collectionId = newVal);
}
